class MY_TICKET_SECTION_TYPES {
    static BOOKING_REQUEST = 'bookingRequest';

    static INTERNAL_QUERIES = 'internalQueries';

    static TRAVCLAN_HELP = 'travclanHelp';
}

export const TICKET_SECTION_TABS = [
    {
        id: MY_TICKET_SECTION_TYPES.BOOKING_REQUEST,
        label: 'Booking Requests',
        dataKey: 'bookingRequestData',
        listKey: 'service_request_list'
    },
    {
        id: MY_TICKET_SECTION_TYPES.INTERNAL_QUERIES,
        label: 'Internal Queries',
        dataKey: 'internalQueriesData',
        listKey: 'open_close_system',
        queryType: 2
    },
    {
        id: MY_TICKET_SECTION_TYPES.TRAVCLAN_HELP,
        label: 'TravClan Help',
        dataKey: 'travclanHelpData',
        listKey: 'open_close_system',
        queryType: 1
    }
];

export const emptyTabState = () => ({
    items: [],
    next: null,
    previous: null,
    count: 0,
    hasMore: false,
    isLoaded: false
});

export const TICKET_OPEN_STATUS = {
    OPEN: 'open',
    CLOSE: 'close'
};

export const TICKET_STATUS_LABEL = {
    [TICKET_OPEN_STATUS.OPEN]: 'Open',
    [TICKET_OPEN_STATUS.CLOSE]: 'Closed'
};

export const TICKET_COUNT_FILTER_CONFIG = {
    [MY_TICKET_SECTION_TYPES.BOOKING_REQUEST]: {
        statusKey: 'oc_status',
        statuses: [TICKET_OPEN_STATUS.OPEN]
    },
    [MY_TICKET_SECTION_TYPES.INTERNAL_QUERIES]: {
        statusKey: 'status',
        statuses: [TICKET_OPEN_STATUS.OPEN]
    },
    [MY_TICKET_SECTION_TYPES.TRAVCLAN_HELP]: {
        statusKey: 'status',
        statuses: [TICKET_OPEN_STATUS.OPEN]
    }
};

export default MY_TICKET_SECTION_TYPES;
